/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {HISTORY, RELEASE_TYPE, Solution} from '@exc/core/src/models/Solution';

export const aemSkyline: Solution = {
  appId: 'aemshell',
  distributionList: ['ORG-VUROSEV-ALL@adobe.com'],
  name: 'Unified Shell AEM',
  path: '/aem/:instanceId',
  sandbox: {
    hideInitialSpinner: true,
    history: {
      type: HISTORY.SERVER,
      config: {
        absolutePaths: true
      }
    },
    sources: {
      dev: {
        discovery: 'https://localhost.corp.adobe.com:8443/bin/unifiedshell/discovery?configid=ims',
        withCredentials: true,
        payload: ['imsOrg', 'imsProfile.reduced', 'path']
      },
      qa: {
        discovery: 'https://localhost.corp.adobe.com:8443/bin/unifiedshell/discovery?configid=ims',
        withCredentials: true,
        payload: ['imsOrg', 'imsProfile.reduced', 'path']
      },
      stage: {
        url: 'https://{instanceId}.adobeaemcloud.com',
        discovery: 'https://{instanceId}.adobeaemcloud.com/bin/unifiedshell/discovery?configid=ims',
        withCredentials: true,
        payload: ['imsOrg', 'imsProfile.reduced', 'path']
      },
      prod: {
        url: 'https://{instanceId}.adobeaemcloud.com',
        discovery: 'https://{instanceId}.adobeaemcloud.com/bin/unifiedshell/discovery?configid=ims',
        withCredentials: true,
        payload: ['imsOrg', 'imsProfile.reduced', 'path']
      }
    }
  }
};

export const aemCfAdmin: Solution = {
  appId: 'aem-cf-admin',
  spaAppId: 'cq-aem-headless-ui-admin',
  distributionList: ['bhellema@adobe.com'],
  name: 'AEM Content Fragement Admin',
  path: '/aem/cf/admin',
  sandbox: {
    history: HISTORY.HISTORY,
    sources: {
      dev: 'https://localhost.corp.adobe.com:12399'
    }
  },
  access: {
    flag: 'aem-headless-cf'
  },
  releaseType: RELEASE_TYPE.BETA
};

export const aemCfEditor: Solution = {
  appId: 'aem-cf-editor',
  spaAppId: 'cq-aem-headless-ui-cf-editor',
  distributionList: ['bhellema@adobe.com'],
  name: 'AEM Content Fragement Editor',
  path: '/aem/cf/editor',
  sandbox: {
    history: HISTORY.HISTORY,
    sources: {
      dev: 'https://localhost.corp.adobe.com:12398'
    }
  },
  access: {
    flag: 'aem-headless-cf'
  },
  releaseType: RELEASE_TYPE.BETA
};
